import { OrderLineModel, OrderModel } from '@core/services/api.service';

export class LoadOrderHistoryAction {
  static readonly type = '[Order] Load Order History Action';
}

export class LoadOrderHistorySuccessAction {
  static readonly type = '[Order] Load Order History Success Action ';

  constructor(public payload: { orderHistory: OrderModel[] }) { }
}

export class LoadOrderHistoryFailAction {
  static readonly type = '[Order] Load Order History Fail Action';
}

export class GetOrderByIdAction {
  static readonly type = '[Order] Get Order Details Action ';  
  constructor(public payload: { id: number }) { }
}
export class GetOrderByIdSuccessAction {
  static readonly type = '[Order] Get Product Order Success Action';
  constructor(public payload: { orderByDetails: OrderModel }) { }
}

export class GetOrderByIdFailAction {
  static readonly type = '[Order] Get Product Order Fail Action';
  constructor(public payload: { response: string }) { }
}



import { CreateOrderCommand } from "@core/services/api.service";

  export class CreateOrderAction {
    static readonly type = '[Create Order] Order';
  
    constructor(public payload: { createOrderCommand: CreateOrderCommand }) { }
  }
  
  export class CreateOrderSuccessAction {
    static readonly type = '[Create Order] Order Success';
  
    constructor(public payload: { createOrderCommand: CreateOrderCommand}) { }
  }
  
  export class CreateOrderFailAction {
    static readonly type = '[Create Order] Order Fail';
    
    constructor(public payload: { response: string }) {}
  }